export default __webpack_public_path__ + "static/media/check-mark.811f998e.svg";